import styled from 'styled-components'

export const Label = styled.span`
  margin-bottom: 8px;
  display: inline-block;
  span {
    color: ${({ theme }) => theme.color.lightGrey};
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  margin-bottom: 24px;
  width: 100%;
  position: relative;
  flex-direction: column;
  width: 100%;
  margin: auto;

  input {
    height: 43px;
    background-color: ${({ theme }) => theme.color.hoverWhite};
    border: 2px solid ${({ theme }) => theme.color.lightGrey} !important;
    border-radius: 5px;
    width: 100%;
    padding: 5px 10px;
    font-size: 12px;
    transition: border 0.3s;
    color: ${({ theme }) => theme.color.slateGrey};
    &::-webkit-input-placeholder {
      color: $color-additional;
    }
    &::-moz-placeholder {
      color: $color-additional;
    }
    /* Firefox 19+ */
    &:-moz-placeholder {
      color: $color-additional;
    }
    /* Firefox 18- */
    &:-ms-input-placeholder {
      color: $color-additional;
    }

    &:focus,
    &:active {
      outline: none;
    }
  }
`

export const Container = styled.div`
  margin-bottom: 24px;
  width: 100%;
  position: relative;
`
export const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 10px;
`
